module.exports.userAchievements = {
  vi: {
    title: 'Avalon: The Resistance | Thành tích cá nhân',
    description: 'Xem thành tích của bạn trong Avalon. Theo dõi tiến trình và mở khóa thành tích mới khi chơi.',
    keywords: ['Thành tích', 'Thành tích cá nhân'],
  },
  en: {
    title: 'Avalon: The Resistance | User Achievements',
    description: 'View your achievements in Avalon Game. Track your progress and unlock new achievements as you play.',
    keywords: ['achievements', 'user achievements'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Достижения пользователя',
    description:
      'Просмотрите свои достижения в Avalon Game. Отслеживайте свой прогресс и разблокируйте новые достижения во время игры.',
    keywords: ['достижения', 'достижения пользователя'],
  },
  es: {
    title: 'Avalon: La Resistencia | Logros del usuario',
    description: 'Ve tus logros en Avalon Game. Sigue tu progreso y desbloquea nuevos logros mientras juegas.',
    keywords: ['logros', 'logros del usuario'],
  },
  pt: {
    title: 'Avalon: The Resistance | Conquistas do usuário',
    description:
      'Veja suas conquistas no Avalon Game. Acompanhe seu progresso e desbloqueie novas conquistas enquanto joga.',
    keywords: ['conquistas', 'conquistas do usuário'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 用户成就',
    description: '查看您在Avalon Game中的成就。跟踪您的进度并在游戏过程中解锁新成就。',
    keywords: ['成就', '用户成就'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 用戶成就',
    description: '查看您在Avalon Game中的成就。跟蹤您的進度並在遊戲過程中解鎖新成就。',
    keywords: ['成就', '用戶成就'],
  },
};
